import React from 'react';
import styled from '@emotion/styled';
import { BsSearch } from 'react-icons/bs';

const Wrapper = styled.div`
  background: white;
  border: 1px solid black;
  border-radius: 15px;
  display: flex;
  overflow: hidden;
  padding: 5px;
  width: 100%;
`;

const IconHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: none;
  flex-grow: 1;
  margin-left: 10px;
`;

export interface TextInputProps {
  color?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent) => void;
  size: number | string;
  value: string;
}

const TextInput: React.FC<TextInputProps> = ({
  size = 20,
  color = 'blue',
  value,
  onChange,
  onClick,
}) => {
  return (
    <Wrapper onClick={onClick}>
      <IconHolder>
        <BsSearch size={size} color={color} />
      </IconHolder>
      <Input value={value} onChange={onChange} placeholder="search" />
    </Wrapper>
  );
};

export default TextInput;
